import SEOBreadcrumb from "@/components/feature/SEOBreadcrumb";

const faqItems = [
  {
    q: "Что такое YOYBUY Spreadsheet и как он работает?",
    a: "YOYBUY Spreadsheet — это инструмент для управления закупками из Китая, построенный вокруг прозрачной таблицы. Вы заполняете ссылки на товары с Taobao, 1688 или Weidian, указываете размеры и количество, а система автоматически рассчитывает полную стоимость с разбивкой по каждому этапу: цена товара, внутренняя доставка по Китаю, комиссия за обработку (3–5%), международная доставка. В отличие от обычных агентов, вы видите каждую копейку расходов.",
  },
  {
    q: "YOYBUY Spreadsheet действительно экономит до 40% по сравнению с SUPERBUY?",
    a: "Да, экономия достигается за счет трех факторов: (1) комиссия YOYBUY 3–5% против 10–15% у SUPERBUY; (2) отсутствие скрытых сборов — фотоотчет, консолидация посылок и базовое хранение включены в стоимость; (3) точный расчет веса до грамма без округления в большую сторону. На заказе в $500 разница составляет $40–60. При регулярных закупках экономия достигает $200–300 в месяц.",
  },
  {
    q: "Безопасно ли использовать YOYBUY Spreadsheet для покупок из Китая?",
    a: "Абсолютно безопасно. YOYBUY работает с проверенными поставщиками и предоставляет полную прозрачность на каждом этапе. Вы получаете оригинальный чек от поставщика, фотоотчет с китайского склада, реальный вес и трек-номер. Все платежи проходят через защищенные каналы. Более 50 000 заказов уже обработано через систему YOYBUY.",
  },
  {
    q: "Сколько времени занимает обработка заказа через YOYBUY Spreadsheet?",
    a: "Среднее время обработки — от 6 до 12 часов после отправки заполненного Spreadsheet. Это в 2–4 раза быстрее, чем у KAKOBUY (12–24 часа) и SUPERBUY (24–48 часов). Скорость достигается за счет прямой передачи таблицы исполнителю без промежуточных менеджеров и ручного переноса данных.",
  },
  {
    q: "Какие торговые площадки поддерживает YOYBUY Spreadsheet?",
    a: "YOYBUY Spreadsheet поддерживает все основные китайские торговые площадки: Taobao, Tmall, 1688, Weidian, JD.com, Pinduoduo и другие. Если площадка принимает заказы из Китая — Spreadsheet с ней работает. Просто вставьте ссылку на товар в таблицу.",
  },
  {
    q: "Сколько стоит международная доставка через YOYBUY?",
    a: "Стоимость международной доставки зависит от веса посылки и выбранного способа: авиа (7–15 дней, от $12/кг), экспресс (3–7 дней, от $18/кг), море (25–40 дней, от $4/кг). YOYBUY Spreadsheet автоматически рассчитывает стоимость для каждого варианта и показывает финальную цену до подтверждения заказа. Вы сами выбираете оптимальный способ.",
  },
  {
    q: "Можно ли объединить несколько заказов в одну посылку?",
    a: "Да, консолидация посылок в YOYBUY Spreadsheet полностью бесплатна. Вы можете накапливать товары на складе до 30 дней бесплатного хранения, а затем отправить все одной посылкой. Это позволяет сэкономить 20–30% на международной доставке по сравнению с отправкой каждой позиции отдельно.",
  },
  {
    q: "Чем YOYBUY отличается от KAKOBUY?",
    a: "Ключевые отличия: (1) комиссия YOYBUY 3–5% против 7–10% у KAKOBUY; (2) обработка за 6–12 часов против 12–24; (3) полная прозрачность с чеками поставщика против частичной детализации; (4) бесплатное хранение 30 дней против 14. Подробное сравнение доступно на специальной странице — рекомендуем ознакомиться для полной картины.",
  },
  {
    q: "Подходит ли YOYBUY Spreadsheet для новичков?",
    a: "Да, интерфейс Spreadsheet интуитивен. Каждая колонка таблицы подписана на русском языке, а к первому заказу прилагается пример заполнения. Если возникнут вопросы, команда поддержки отвечает в течение 2–4 часов. Новички обычно осваивают систему за 5–10 минут.",
  },
  {
    q: "Как начать использовать YOYBUY Spreadsheet прямо сейчас?",
    a: "Процесс занимает 3 шага: (1) Перейдите на основную платформу; (2) выберите категорию товара и скопируйте ссылки с китайских площадок; (3) заполните Spreadsheet и отправьте на расчет. В течение 6–12 часов вы получите детальную стоимость с фото и сроками. После подтверждения оплаты заказ уходит в обработку.",
  },
  {
    q: "Есть ли минимальная сумма заказа?",
    a: "Официального минимального порога нет, но для максимальной эффективности Spreadsheet рекомендуем заказы от $100. При маленьких заказах (до $50) фиксированная стоимость доставки может сделать покупку менее выгодной. Однако даже на заказе в $50–80 Spreadsheet помогает сэкономить за счет прозрачности и точного расчета.",
  },
  {
    q: "Что делать, если товар пришел с браком или не соответствует описанию?",
    a: "YOYBUY Spreadsheet включает этап проверки качества на китайском складе. Команда делает фотоотчет каждого товара перед отправкой. Если обнаружен брак или несоответствие описанию, вы можете отказаться от товара до международной отправки, и деньги за сам товар будут возвращены. Комиссия за обработку в этом случае не возвращается, так как проверка уже проведена.",
  },
];

export default function FAQ() {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqItems.map((item) => ({
      "@type": "Question",
      name: item.q,
      acceptedAnswer: {
        "@type": "Answer",
        text: item.a,
      },
    })),
  };

  return (
    <article className="bg-background-50 min-h-screen pt-20">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <div className="relative w-full h-[240px] md:h-[340px]">
        <img
          src="https://readdy.ai/api/search-image?query=Minimalist%20soft%20focused%20workspace%20with%20open%20notebook%20and%20pen%2C%20warm%20cream%20tones%2C%20gentle%20natural%20light%2C%20calm%20and%20inviting%20atmosphere%2C%20small%20vase%20with%20dried%20flowers%2C%20clean%20modern%20aesthetic%2C%20editorial%20photography%20with%20shallow%20depth%20of%20field%2C%20no%20text%2C%20peaceful%20productive%20vibe&width=1200&height=600&seq=faq-page-header&orientation=landscape"
          alt="YOYBUY FAQ"
          className="w-full h-full object-cover object-top"
          loading="lazy"
          width={1200}
          height={600}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/30" />
        <div className="absolute inset-0 flex items-end">
          <div className="w-full px-4 md:px-8 pb-8 md:pb-12 max-w-4xl mx-auto">
            <h1 className="text-2xl md:text-4xl font-bold text-white font-heading leading-tight">
              YOYBUY Spreadsheet — Часто задаваемые вопросы
            </h1>
          </div>
        </div>
      </div>

      <div className="w-full px-4 md:px-8 py-8 md:py-12 max-w-3xl mx-auto">
        <SEOBreadcrumb
          items={[
            { label: "Главная", href: "/" },
            { label: "FAQ" },
          ]}
        />

        <div className="mb-8">
          <p className="text-foreground-700 text-sm md:text-base leading-relaxed mb-4">
            Мы собрали ответы на самые популярные вопросы о <strong>YOYBUY Spreadsheet</strong>. Если вы не нашли ответ на свой вопрос, <a href="/" className="text-primary-600 hover:text-primary-700 underline">вернитесь на главную страницу</a> и воспользуйтесь категориями для перехода к нужному разделу.
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, idx) => (
            <details key={idx} className="group bg-white border border-background-200 rounded-lg transition-colors hover:border-primary-200">
              <summary className="flex items-center justify-between cursor-pointer p-4 md:p-5 list-none">
                <span className="text-sm md:text-base font-medium text-foreground-900 pr-8 font-heading">
                  {item.q}
                </span>
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 text-foreground-400 group-open:text-primary-500 transition-colors">
                  <i className="ri-arrow-down-s-line text-lg group-open:rotate-180 transition-transform duration-200" />
                </div>
              </summary>
              <div className="px-4 md:px-5 pb-4 md:pb-5 -mt-1">
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                  {item.a}
                </p>
              </div>
            </details>
          ))}
        </div>

        <div className="bg-background-100 rounded-lg p-5 md:p-6 my-10">
          <p className="text-foreground-600 text-sm leading-relaxed mb-3">
            Полезные страницы:
          </p>
          <div className="flex flex-wrap gap-3">
            <a href="/yoybuy-vs-kakobuy" className="text-sm text-primary-600 hover:text-primary-700 underline">YOYBUY vs KAKOBUY</a>
            <span className="text-foreground-300">|</span>
            <a href="/yoybuy-vs-superbuy" className="text-sm text-primary-600 hover:text-primary-700 underline">YOYBUY vs SUPERBUY</a>
            <span className="text-foreground-300">|</span>
            <a href="/kakobuy-vs-superbuy" className="text-sm text-primary-600 hover:text-primary-700 underline">KAKOBUY vs SUPERBUY</a>
            <span className="text-foreground-300">|</span>
            <a href="/superbuy-alternative" className="text-sm text-primary-600 hover:text-primary-700 underline">Альтернативы SUPERBUY</a>
            <span className="text-foreground-300">|</span>
            <a href="/article" className="text-sm text-primary-600 hover:text-primary-700 underline">Полное руководство</a>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 pt-6 border-t border-background-200">
          <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="inline-block bg-primary-500 hover:bg-primary-600 text-white font-medium px-6 py-3 rounded-md whitespace-nowrap transition-colors text-center">
            yoybuy sheet
          </a>
          <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="inline-block bg-accent-500 hover:bg-accent-600 text-white font-medium px-6 py-3 rounded-md whitespace-nowrap transition-colors text-center">
            buy it now
          </a>
          <a href="/" className="inline-block bg-white border border-background-200 hover:border-primary-400 text-foreground-900 font-medium px-6 py-3 rounded-md whitespace-nowrap transition-colors text-center">
            Вернуться на главную
          </a>
        </div>
      </div>
    </article>
  );
}